// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function customer_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var customer_id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "customer_id"), null));
  if (customer_id.TAG === /* Ok */0) {
    var customer_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "customer_name"), null));
    if (customer_name.TAG === /* Ok */0) {
      var vendor_name = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "vendor_name"), null));
      if (vendor_name.TAG === /* Ok */0) {
        var primary_number = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "primary_number"), null));
        if (primary_number.TAG === /* Ok */0) {
          var secondary_number = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "secondary_number"), null));
          if (secondary_number.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      customer_id: customer_id._0,
                      customer_name: customer_name._0,
                      vendor_name: vendor_name._0,
                      primary_number: primary_number._0,
                      secondary_number: secondary_number._0
                    }
                  };
          }
          var e = secondary_number._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".secondary_number" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = primary_number._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".primary_number" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = vendor_name._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".vendor_name" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = customer_name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".customer_name" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = customer_id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".customer_id" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function partner_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var msisdn = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "msisdn"), null));
  if (msisdn.TAG === /* Ok */0) {
    var uuid = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "uuid"), null));
    if (uuid.TAG === /* Ok */0) {
      var partner_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "partner_name"), null));
      if (partner_name.TAG === /* Ok */0) {
        var primary_number = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "primary_number"), null));
        if (primary_number.TAG === /* Ok */0) {
          var secondary_number = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "secondary_number"), null));
          if (secondary_number.TAG === /* Ok */0) {
            var owner_number = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "owner_number"), null));
            if (owner_number.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        msisdn: msisdn._0,
                        uuid: uuid._0,
                        partner_name: partner_name._0,
                        primary_number: primary_number._0,
                        secondary_number: secondary_number._0,
                        owner_number: owner_number._0
                      }
                    };
            }
            var e = owner_number._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".owner_number" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = secondary_number._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".secondary_number" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = primary_number._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".primary_number" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = partner_name._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".partner_name" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = uuid._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".uuid" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = msisdn._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".msisdn" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var customer = Decco.optionFromJson(customer_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "customer"), null));
  if (customer.TAG === /* Ok */0) {
    var partners = Decco.listFromJson(partner_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "partners"), null));
    if (partners.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                customer: customer._0,
                partners: partners._0
              }
            };
    }
    var e = partners._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".partners" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = customer._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".customer" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

export {
  customer_decode ,
  partner_decode ,
  t_decode ,
  
}
/* No side effect */
